import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';
import { Trip, Traveller, Apartment } from '@/types';
import TripDashboardSection from '../TripDashboardSection';
import EnhancedBillOverview from '@/components/bill/EnhancedBillOverview';
import { listenToTripById } from '@/services/tripService';
import { travellerService } from '@/services/travellerService';
import { apartmentService } from '@/services/apartmentService';
import * as billCalculationService from '@/services/billCalculationService';
import { useI18n } from '@/hooks/useI18n';

interface TripBillsPageProps {
  trip: Trip;
}

const TripBillsPage: React.FC<TripBillsPageProps> = ({ trip }) => {
  const { tripId } = useParams<{ tripId: string }>();
  const [travellers, setTravellers] = useState<Traveller[]>([]);
  const [apartments, setApartments] = useState<Apartment[]>([]);
  const { t } = useI18n();

  useEffect(() => {
    if (!tripId) return;

    const unsubscribeTravellers = travellerService.listenToTravellers(tripId, setTravellers);
    const unsubscribeApartments = apartmentService.listenToApartments(tripId, setApartments);

    return () => {
      unsubscribeTravellers();
      unsubscribeApartments();
    };
  }, [tripId]);

  const handleExportToCsv = () => {
    billCalculationService.exportBillsToCsv(trip, apartments, travellers);
  };

  return (
    <TripDashboardSection
      icon="🧾"
      title={t('trip.pages.bills.title')}
      subtitle={t('trip.pages.bills.subtitle')}
      description={t('trip.pages.bills.description')}
      primaryAction={{
        icon: <Download />,
        onClick: handleExportToCsv,
        label: t('trip.pages.bills.exportToExcel')
      }}
    >
      <EnhancedBillOverview />
    </TripDashboardSection>
  );
};

export default TripBillsPage;
